import { PLATFORM_HOST } from './const';

export function getUrl(subdomain: string, path = '') {
    const u = new URL(`//${subdomain}.${PLATFORM_HOST}${path}`, window.location.origin);
    u.port = window.location.port;

    return u.href;
}
